import { API_BASE_URL, apiGet } from '@/api/http';

import type { Certificate } from '@/types/reference';

export const getCertificatesList = () =>
  apiGet<Certificate[]>(`${API_BASE_URL}certificates/`);
